var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFastloadingBro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.18,367.7c2.6-5.8,14.13-33.77,17.48-81.56,3.8-54-10.43-106.82-41.72-140.13s-57.84-25.28-89.13-17.24c-16.87,4.34-31.23-1.29-46.8-7.23-43.95-16.74-87.77-5.94-112.67,35.75-8.12,13.6-10.84,26.54-11.42,42.09s-.75,32.21-12.12,44.26c-15.17,16.08-36,13.79-49.31,40.21s-15.17,52.84-22.76,58.58-13.27,4.59-19,11.49c-3.62,4.38-4.94,10.16-5.42,13.78Z",
    style: {
      fill: "#F96167"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.18,367.7c2.6-5.8,14.13-33.77,17.48-81.56,3.8-54-10.43-106.82-41.72-140.13s-57.84-25.28-89.13-17.24c-16.87,4.34-31.23-1.29-46.8-7.23-43.95-16.74-87.77-5.94-112.67,35.75-8.12,13.6-10.84,26.54-11.42,42.09s-.75,32.21-12.12,44.26c-15.17,16.08-36,13.79-49.31,40.21s-15.17,52.84-22.76,58.58-13.27,4.59-19,11.49c-3.62,4.38-4.94,10.16-5.42,13.78Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343,166.74c.93-.31-2.88-11.4-3.22-12.44-2.35-7.18-8.19-14.22-16.34-14.07s-17.55,11.5-25.68,6.88c-6.72-3.81-10.34-11.2-17.71-14.17-13.94-5.63-13.95,9.22-24.16,11.58-7.81,1.8-10.21-4.81-17.42.6s-2.41,7.81-10.21,9-9-.6-13.82,1.2-13.22,10.81-13.22,10.81-6.6-2.4-12.61,0-8.41,6-8.41,6h170S348.36,165.54,343,166.74Z",
    style: {
      fill: "#F96167"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424,192.34c.49-.17-1.53-6.08-1.72-6.64-1.25-3.82-4.37-7.58-8.71-7.5s-9.36,6.13-13.69,3.67c-3.59-2-5.52-6-9.45-7.56-7.43-3-7.43,4.92-12.88,6.18-4.16,1-5.44-2.56-9.29.32s-1.28,4.17-5.44,4.81-4.81-.32-7.37.64-7,5.76-7,5.76a10.57,10.57,0,0,0-6.72,0,10,10,0,0,0-4.49,3.2h90.65S426.89,191.7,424,192.34Z",
    style: {
      fill: "#F96167"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343,166.74c.93-.31-2.88-11.4-3.22-12.44-2.35-7.18-8.19-14.22-16.34-14.07s-17.55,11.5-25.68,6.88c-6.72-3.81-10.34-11.2-17.71-14.17-13.94-5.63-13.95,9.22-24.16,11.58-7.81,1.8-10.21-4.81-17.42.6s-2.41,7.81-10.21,9-9-.6-13.82,1.2-13.22,10.81-13.22,10.81-6.6-2.4-12.61,0-8.41,6-8.41,6h170S348.36,165.54,343,166.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424,192.34c.49-.17-1.53-6.08-1.72-6.64-1.25-3.82-4.37-7.58-8.71-7.5s-9.36,6.13-13.69,3.67c-3.59-2-5.52-6-9.45-7.56-7.43-3-7.43,4.92-12.88,6.18-4.16,1-5.44-2.56-9.29.32s-1.28,4.17-5.44,4.81-4.81-.32-7.37.64-7,5.76-7,5.76a10.57,10.57,0,0,0-6.72,0,10,10,0,0,0-4.49,3.2h90.65S426.89,191.7,424,192.34Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.25,211.06H427.12a4.29,4.29,0,0,1,4.29,4.29V356.73a0,0,0,0,1,0,0H231a0,0,0,0,1,0,0V215.35A4.29,4.29,0,0,1,235.25,211.06Z",
    style: {
      fill: "#F96167",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,222.12H415.36a4.29,4.29,0,0,1,4.29,4.29V358.69a0,0,0,0,1,0,0H242.72a0,0,0,0,1,0,0V226.41A4.29,4.29,0,0,1,247,222.12Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.46,368.5H222.73c-10.83,0-19.62-6.56-19.62-14.65h246C449.07,361.94,440.29,368.5,429.46,368.5Z",
    style: {
      fill: "#F96167",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.83,
    y: 274.8,
    width: 106.53,
    height: 17.85,
    rx: 5,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.55,
    y: 278.04,
    width: 9.08,
    height: 11.36,
    style: {
      fill: "#F96167",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.59,
    y: 278.04,
    width: 9.08,
    height: 11.36,
    style: {
      fill: "#F96167",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.62,
    y: 278.04,
    width: 9.08,
    height: 11.36,
    style: {
      fill: "#F96167",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.65,
    y: 278.04,
    width: 9.08,
    height: 11.36,
    style: {
      fill: "#F96167",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.76,278h-4.47a5.68,5.68,0,0,0,0,11.36h4.47Z",
    style: {
      fill: "#F96167",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.52,
    y: 278.04,
    width: 9.08,
    height: 11.36,
    style: {
      fill: "#F96167",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 235.88,
    y1: 220.98,
    x2: 181.95,
    y2: 220.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 235.88,
    y1: 276.48,
    x2: 206.56,
    y2: 276.48,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200.8,
    y1: 276.48,
    x2: 188.76,
    y2: 276.48,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 235.88,
    y1: 255.87,
    x2: 175.67,
    y2: 255.87,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 235.88,
    y1: 245.93,
    x2: 219.12,
    y2: 245.93,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 235.88,
    y1: 301.26,
    x2: 175.67,
    y2: 301.26,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 235.88,
    y1: 323.19,
    x2: 219.12,
    y2: 323.19,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 199.23,
    y1: 230.41,
    x2: 145.3,
    y2: 230.41,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 136.93,
    y1: 230.41,
    x2: 125.41,
    y2: 230.41,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Car--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.51,331.23a7.51,7.51,0,0,1,6.25-9c7.8-1.76,9,7.61,9.17,9.95Z",
    style: {
      fill: "#F96167",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.34,326.55h-7.22v1.95l7.81,3.71A10.77,10.77,0,0,0,191.34,326.55Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.35,311.33v35.9s13.26,4.29,23.6,8.59a237,237,0,0,1,21.47,10.53H233.1s-11.32.39-13.27-1.36-1.56-5.66,1.95-8,23.61-3.12,23.61-3.12,71.41-3.91,71.8-5.08.39-2.14-1.36-2.73-31-9.17-52.88-12.1-41.17-1.75-45.66-.39-16.39-.39-24.58-1.95a129.7,129.7,0,0,0-15.22-1.95v-7.22h-7.22v-2.14h2.93V310.16a45.68,45.68,0,0,0-18.74,1.76c-10,3.12-20.48,13.65-28.29,18.14s-16.58,6.83-20.87,6.83a21.2,21.2,0,0,1-7.22-1.17v-7.8l3.7-3.91V309.38H83.44s-.19,3.51-3.31,3.71S71.35,311.33,71.35,311.33Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.08,328.17v-.25l3.7-3.91V309.38H83.44s-.19,3.51-3.31,3.71-8.78-1.76-8.78-1.76v33.75C75.53,340,83.41,333.44,98.08,328.17Z",
    style: {
      fill: "#F96167",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.95 351.12 125.33 351.12 137.67 366.35 148.35 366.35 134.95 351.12",
    style: {
      fill: "#F96167",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.04 351.12 141.43 351.12 153.76 366.35 164.44 366.35 151.04 351.12",
    style: {
      fill: "#F96167",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.37,360.64c-8.63-2.16-13.49-9.18-17.27-16.2s-12.69-14-15.66-13.76-9.71,1.35-9.71,1.35-2.43-1.08-11.88-6.75a35.63,35.63,0,0,0-8-3.54,138.29,138.29,0,0,1-11.31,8.12q2.76.06,6.38.28c8.91.54,11.61,5.4,11.61,5.4a33.85,33.85,0,0,1,5.94-.54c3.24,0,13.22,8.36,15.65,17,1.56,5.55,6.69,11.1,10.15,14.35h47.63C215.53,364.34,205.15,361.83,200.37,360.64Z",
    style: {
      fill: "#F96167",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.1,366.35h-5.19C230.69,366.44,233.1,366.35,233.1,366.35Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.78,357c3.51-2.34,23.61-3.12,23.61-3.12s25.59-1.4,46.22-2.78c-13.05-.69-51.77-2.58-60.66-1.13-10.73,1.76-31.61,6.25-43.32,11.32s-26.53.2-54.82-3.12c-20-2.35-37-4.31-45.25-5.25,2.49.93,5,1.92,7.39,2.91a237,237,0,0,1,21.47,10.53H227.91c-3.25-.09-7-.42-8.08-1.36C217.88,363.23,218.27,359.33,221.78,357Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.65,
    cy: 349.09,
    r: 19.41,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.31
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.78,338.28,264.4,348.64l19.29-3.38A19.28,19.28,0,0,0,280.78,338.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.88,358.85l16.77-9.76-19.23,2.64A19.09,19.09,0,0,0,247.88,358.85Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M246.87,356.87l9.89-5.06-10.94,2A18.71,18.71,0,0,0,246.87,356.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.18,345.63l11-2.32a19.35,19.35,0,0,0-1.35-3.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.65,
    cy: 349.09,
    r: 11.41,
    style: {
      fill: "#F96167",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.65,
    cy: 349.09,
    r: 3.02,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.05 351.33 295.53 356.6 307.83 356.6 304.9 349.96 291.05 351.33",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.49,356.21v9.56H320.9v-8.2s-7.81-.58-15.61-1.95S291.24,354.84,289.49,356.21Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221,354.45v9.76H198.56v-2.73s6.83-1.17,10.34-3.52S214.76,354.26,221,354.45Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.19,338.26h-8.78s-3.7.78-3.31,4.09,3.12,7,4.68,7H220",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.41,342c1-4.48,4.3-3.31,4.3-3.31l-.56-.39h-3.74s-3.7.78-3.31,4.09,3.12,7,4.68,7A9.29,9.29,0,0,1,204.41,342Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.69,344.7c11.12-1.76,32-9.17,32-9.17,14.44-6,31.81-5.86,31.81-5.86",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.49,349.18s33.76-6.44,60.29-10.92,41.37-2.15,47-3.12,8.78-2.54,13.86-2.74",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.63,310l-1.95-3.13s2.35-1.36-.58-1.56-6.44,0-6.83.78,2.54.59,2.54.59V310Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101.49,
    cy: 349.09,
    r: 19.41,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.31
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.62,338.28l-16.38,10.36,19.29-3.38A19.45,19.45,0,0,0,117.62,338.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.72,358.85l16.77-9.76-19.23,2.64A19.09,19.09,0,0,0,84.72,358.85Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M83.71,356.87l9.89-5.06-10.94,2A18.71,18.71,0,0,0,83.71,356.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109,345.63l11-2.32a19.35,19.35,0,0,0-1.35-3.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101.49,
    cy: 349.09,
    r: 11.41,
    style: {
      fill: "#F96167",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101.49,
    cy: 349.09,
    r: 3.02,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 162.24,
    y1: 314.84,
    x2: 132.92,
    y2: 314.84,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 75.19,
    y1: 323.6,
    x2: 45.87,
    y2: 323.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 75.19,
    y1: 335.87,
    x2: 58.6,
    y2: 335.87,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 136.54,
    y1: 324.77,
    x2: 119.95,
    y2: 324.77,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 127.16,
    y1: 314.84,
    x2: 115.12,
    y2: 314.84,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-64"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 35.8,
    y1: 368.5,
    x2: 465.83,
    y2: 368.5,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastloadingBro);
export default __webpack_public_path__ + "static/media/Fast loading-bro.e1be7f311633a06f25118a5119860ca1.svg";
export { ForwardRef as ReactComponent };